import { OptionSelect } from './../../../../../../../shared/select/select.component';
import { LoaderService } from './../../../../../../../shared/loader/loader.service';
import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ModalComponent } from '../../../../../../../shared/modal/modal.component';
import { ButtonComponent } from '../../../../../../../shared/button/button.component';
import { DividerComponent } from '../../../../../../../shared/divider/divider.component';
import { InputIconComponent } from '../../../../../../../shared/input-icon/input-icon.component';
import { CheckboxComponent } from '../../../../../../../shared/checkbox/checkbox.component';
import { ToggleComponent } from '../../../../../../../shared/toggle/toggle.component';
import { TextareaComponent } from '../../../../../../../shared/textarea/textarea.component';
import { SelectComponent } from '../../../../../../../shared/select/select.component';
import { ChipsSelectsComponent } from '../../../../../../../shared/chips-selects/chips-selects.component';
import { ModalService } from '../../../../../../../shared/modal/modal.service';
import { SelectColorComponent } from '../../../../../../../shared/select-color/select-color.component';
import { UserService } from '../../../../../../../shared/services/user/user.service';
import { User } from '../../../../../../../models/authentication.interface';
import {
  AgendaRequest,
  EnviarPara,
} from '../../../../../../../models/agenda.interface';
import { Post, toPost } from '../../../../../../../models/rest.interface';
import { AgendaService } from '../../agenda.service';
import { ToastService } from '../../../../../../../shared/toast/toast.service';
import { TurmasService } from '../../../../turmas/turmas.service';
import {
  Tab,
  TabsComponent,
} from '../../../../../../../shared/tabs/tabs.component';
import { steps } from '../../../../../../../shared/stepper/stepper.component';
import { escolaBehavior } from '../../../../../../../models/escola.interface';

@Component({
  selector: 'app-criar-evento',
  standalone: true,
  imports: [
    ModalComponent,
    ButtonComponent,
    DividerComponent,
    InputIconComponent,
    CheckboxComponent,
    ToggleComponent,
    TextareaComponent,
    SelectComponent,
    ChipsSelectsComponent,
    SelectColorComponent,
    TabsComponent,
  ],
  templateUrl: './criar-evento.component.html',
  styleUrl: './criar-evento.component.scss',
})
export class CriarEventoComponent implements OnInit {
  @Input() data: any;

  files: File[] = [];
  tabSelected: string = 'evento';
  chips: any[] = [];
  campoObrigatorio: boolean = false;
  diaInteiro: boolean = false;
  todasTurmas: boolean = false;
  optionTurmas: OptionSelect[] = [];
  enviarParaSelected!: OptionSelect;
  categoriaSelected!: OptionSelect;
  idsTurmas: OptionSelect[] = [];
  uploadedFiles: any[] = [];

  form = new FormGroup({
    enviarPara: new FormControl('', Validators.required),
    data: new FormControl('', Validators.required),
    diaInteiro: new FormControl(false),
    assunto: new FormControl('', Validators.required),
    descricao: new FormControl('', Validators.required),
    horaInicio: new FormControl(''),
    horaFim: new FormControl(''),
    dataLembrete: new FormControl('', Validators.required),
    color: new FormControl('sem_cor', Validators.required),
    escola: new FormControl<number | null>(null, Validators.required),
    categoria: new FormControl('', Validators.required),
    idsTurmas: new FormControl<number[]>([]),
    arquivo: new FormControl<any[]>([]),
    enviarTodasTurmas: new FormControl(false),
  });

  steps: Tab[] = [
    {
      label: 'Evento',
      value: 'evento',
      selected: true,
      icon: '',
    },
    {
      label: 'Arquivo',
      value: 'arquivo',
      selected: false,
      icon: '',
    },
  ];

  constructor(
    private readonly modalService: ModalService,
    private readonly userSercice: UserService,
    private readonly agendaService: AgendaService,
    private readonly toast: ToastService,
    private readonly loaderService: LoaderService,
    private readonly turmasService: TurmasService,
  ) {}

  ngOnInit(): void {
    if(this.userSercice.escolaSelecionada !== undefined) {
      this.form.controls.escola.setValue(this.userSercice.escolaSelecionada.id);
    } else {
      console.warn('Escola não selecionada!');
    }
    this.form.controls.data.setValue(this.data.dateStr);
    // this.form.controls.dataLembrete.setValue(this.data.dateStr);
    this.loaderService
      .executeWithLoader(
        this.turmasService.listarPorEscolas({ page: 1, pageSize: 10000 }),
      )
      .subscribe({
        next: (value) => {
          this.optionTurmas = value.data.map((opt: any) => {
            return { label: opt.nome, value: opt.id };
          });
        },
        error: (err) => {
          this.toast.notify({
            message: 'Erro ao listar Turmas.',
            type: 'ERROR',
          });
        },
      });
  }

  removerArquivo(index: number) {
    this.files.splice(index, 1);
    this.uploadedFiles.splice(index, 1);
    this.form.controls.arquivo.setValue(this.uploadedFiles);
  }

  salvarArquivo(event: any) {
    const selectedFiles = event.target.files;
    if (selectedFiles) {
      for (let i = 0; i < selectedFiles.length; i++) {
        const file = selectedFiles[i];

        // Validar tamanho do arquivo (200MB)
        if (file.size > 200 * 1024 * 1024) {
          this.toast.notify({
            message: `Arquivo ${file.name} excede o tamanho máximo de 200MB.`,
            type: 'ERROR',
          });
          continue;
        }

        // Validar tipo de arquivo
        const allowedTypes = ['image/', 'application/', 'video/', 'audio/'];
        const isValidType = allowedTypes.some(type => file.type.startsWith(type));

        if (!isValidType) {
          this.toast.notify({
            message: `Tipo de arquivo ${file.name} não é suportado.`,
            type: 'ERROR',
          });
          continue;
        }

        this.files.push(file);
      }
    }
  }

  optionsPerfis: OptionSelect[] = [
    {
      label: 'Todos',
      value: EnviarPara.TODOS,
    },
    {
      label: 'Professores',
      value: EnviarPara.PROFESSORES,
    },
    {
      label: 'Pais',
      value: EnviarPara.PAIS,
    },
    {
      label: 'Coordenadores',
      value: EnviarPara.COORDENADORES,
    },
    {
      label: 'Diretoria',
      value: EnviarPara.DIRETORIA,
    },
  ];

  optionsCategoria: OptionSelect[] = [
    {
      label: 'Comunicados',
      value: 'Comunicados',
    },
    {
      label: 'Atividades Acadêmicas',
      value: 'Atividades Acadêmicas',
    },
    {
      label: 'Evento Especial',
      value: 'Evento Especial',
    },
    {
      label: 'Atividades Extraescolares',
      value: 'Atividades Extraescolares',
    },
    {
      label: 'Assuntos Administrativos',
      value: 'Assuntos Administrativos',
    },
  ];

  changeTabs(event: any) {
    this.tabSelected = event;
  }

  removerTurma(idTurma: number) {
    this.idsTurmas.splice(idTurma, 1);
  }

  async agendar() {
    // Verificar se o campo escola está preenchido
    if (!this.form.controls.escola.value) {
      this.toast.notify({
        message: 'Escola não selecionada. Por favor, selecione uma escola.',
        type: 'ERROR',
      });
      return;
    }

    if (this.form.valid) {
      try {
        // Upload de arquivos se existirem
        if (this.files.length > 0) {
          await this.uploadFiles();
        }

        // Preparar dados do formulário
        const formData = this.prepareFormData();

        this.loaderService
          .executeWithLoader(
            this.agendaService.cadastrar(toPost(formData)),
          )
          .subscribe({
            next: (response) => {
              this.toast.notify({
                message: 'Evento registrado com sucesso. As notificações foram enviadas automaticamente.',
                type: 'SUCCESS',
              });
              this.modalService.close(CriarEventoComponent);
              this.agendaService.cadastroCompleto.emit();
            },
            error: (error) => {
              console.error('Erro ao cadastrar evento:', error);
              this.toast.notify({
                message: 'Ocorreu um erro ao tentar cadastrar o evento.',
                type: 'ERROR',
              });
            },
          });
      } catch (error) {
        console.error('Erro no processo de agendamento:', error);
        this.toast.notify({
          message: 'Erro ao processar arquivos ou cadastrar evento.',
          type: 'ERROR',
        });
      }
    } else {
      this.campoObrigatorio = true;
      this.toast.notify({
        message: 'Por favor, preencha todos os campos obrigatórios.',
        type: 'WARNING',
      });
    }
  }

  private async uploadFiles(): Promise<void> {
    const uploadPromises = this.files.map(async (file) => {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('entityId', (this.form.controls.escola.value || '').toString());
      formData.append('contentType', 'api::agenda.agenda');
      formData.append('field', 'arquivo');

      return new Promise((resolve, reject) => {
        this.agendaService.salvarArquivoAgenda(formData).subscribe({
          next: (response) => {
            this.uploadedFiles.push(response.file);
            resolve(response);
          },
          error: (error) => {
            console.error('Erro ao fazer upload do arquivo:', file.name, error);
            reject(error);
          },
        });
      });
    });

    await Promise.all(uploadPromises);
  }

  private prepareFormData(): any {
    const formValue = this.form.value;

    // Preparar IDs das turmas
    const turmasIds = this.idsTurmas.map(turma => turma.value);

    const data = {
      ...formValue,
      idsTurmas: turmasIds,
      arquivo: this.uploadedFiles.map(file => file.id),
      // Garantir que os campos obrigatórios estejam presentes
      enviarPara: formValue.enviarPara,
      data: formValue.data,
      assunto: formValue.assunto,
      descricao: formValue.descricao,
      categoria: formValue.categoria,
      // Para relações no Strapi, enviar apenas o ID
      escola: formValue.escola ? Number(formValue.escola) : null,
    };

    return data;
  }

  changeTurmaOption(event: any) {
    if (!this.idsTurmas.includes(event)) {
      this.idsTurmas.push(event);
    }
  }

  change(allDay: boolean) {
    this.form.controls.diaInteiro.setValue(allDay);

    // Limpar horários se for dia inteiro
    if (allDay) {
      this.form.controls.horaInicio.setValue('');
      this.form.controls.horaFim.setValue('');
    }
  }

  changeTurmas(todasTurmas: boolean) {
    this.form.controls.enviarTodasTurmas.setValue(todasTurmas);
    if (todasTurmas) {
      this.idsTurmas = [];
    }
  }

  cancelar() {
    this.modalService.close(CriarEventoComponent);
  }

  // Validações adicionais
  validateTimeRange(): boolean {
    const horaInicio = this.form.controls.horaInicio.value;
    const horaFim = this.form.controls.horaFim.value;
    const diaInteiro = this.form.controls.diaInteiro.value;

    if (diaInteiro) {
      return true;
    }

    if (!horaInicio || !horaFim) {
      this.toast.notify({
        message: 'Para eventos com horário específico, informe hora de início e fim.',
        type: 'WARNING',
      });
      return false;
    }

    if (horaInicio >= horaFim) {
      this.toast.notify({
        message: 'A hora de fim deve ser posterior à hora de início.',
        type: 'WARNING',
      });
      return false;
    }

    return true;
  }

  validateTurmas(): boolean {
    const enviarPara = this.form.controls.enviarPara.value;
    const enviarTodasTurmas = this.form.controls.enviarTodasTurmas.value;
    const idsTurmas = this.idsTurmas;

    if (enviarPara === 'Pais' && !enviarTodasTurmas && idsTurmas.length === 0) {
      this.toast.notify({
        message: 'Para enviar para pais, selecione pelo menos uma turma ou marque "Todas".',
        type: 'WARNING',
      });
      return false;
    }

    return true;
  }
}
